
    import I18n from 'i18nObj';
    
      import 'translations/assignments.date_available_column_view';
      import 'translations/_core';
    
    import 'translations/_core_en';

    export default I18n.scoped('assignments.date_available_column_view');
  